import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen, Gift, Smartphone } from 'lucide-react';
export function OfferSection() {
  const items = [{
    icon: <BookOpen className="w-6 h-6 text-brand-teal" data-id="element-77" />,
    title: 'Ebook RESET DIGITAL',
    value: '$97',
    desc: 'El mapa exacto de 21 días.'
  }, {
    icon: <Smartphone className="w-6 h-6 text-brand-coral" data-id="element-78" />,
    title: 'Bonus 1: El Botón de Pánico',
    value: '$47',
    desc: 'Qué hacer durante la crisis.'
  }, {
    icon: <Gift className="w-6 h-6 text-brand-gold" data-id="element-79" />,
    title: 'Bonus 2: Guía de Cenas Sin WiFi',
    value: '$6.39',
    desc: 'Recupera la charla en la mesa.'
  }];
  return <section className="py-20 px-4 bg-brand-navy text-brand-cream" data-id="element-80">
      <div className="max-w-4xl mx-auto" data-id="element-81">
        <div className="text-center mb-16" data-id="element-82">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-83">
            Hoy no solo te llevas un libro.
            <br data-id="element-84" />
            <span className="text-brand-gold" data-id="element-85">
              Te llevas el sistema completo para transformar tu hogar:
            </span>
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex justify-center mb-14" data-id="element-86">
          <img src="https://cdn.magicpatterns.com/uploads/sTz38MzWAkX1ii4vougr5G/heylloyd-image-1775249726906.png" alt="Paquete completo RESET DIGITAL con todos los bonos" className="w-full max-w-md md:max-w-lg rounded-2xl drop-shadow-[0_20px_40px_rgba(212,168,83,0.2)]" data-id="element-87" />
        </motion.div>

        <div className="space-y-6" data-id="element-88">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 p-6 rounded-2xl flex flex-col md:flex-row items-start md:items-center gap-6" data-id="element-89">
              <div className="bg-white/10 p-4 rounded-xl flex-shrink-0" data-id="element-90">
                {item.icon}
              </div>
              <div className="flex-grow" data-id="element-91">
                <h3 className="text-xl font-bold mb-1 flex items-center gap-2" data-id="element-92">
                  {item.title}
                </h3>
                <p className="text-brand-cream/70" data-id="element-93">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 text-right" data-id="element-94">
                <p className="text-sm text-brand-cream/50 uppercase tracking-wider" data-id="element-95">
                  Valor Normal
                </p>
                <p className="text-xl font-bold text-brand-cream/40 line-through" data-id="element-96">
                  {item.value}
                </p>
              </div>
            </motion.div>)}

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="bg-brand-gold/10 border border-brand-gold/30 p-6 rounded-2xl text-center mt-8" data-id="element-97">
            <p className="text-xl font-bold text-brand-gold flex items-center justify-center gap-2" data-id="element-98">
              <CheckCircle2 className="w-6 h-6" data-id="element-99" />+ 13 Bonos Adicionales de
              Implementación Rápida.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}